export default {"src":"/_next/static/media/ssbLogoDark.d36ac8ad.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};